const ValidationError = require('./errors/ValidationError');
const AccountLimitsValidationService = require('./AccountLimitsValidationService');
const { errors } = require('@transfeeradev/api-enums');

class BilletValidationService extends AccountLimitsValidationService {
  constructor(args = {}) {
    super(args, {
      MAX_VALUE: errors.ptBr.bil.MAX_VALUE
    });
  }

  validate() {
    try {
      this.validateMaxValue();
    } catch (error) {
      throw new ValidationError(error.message, error.field, null, error.code, error.data);
    }
  }
}

module.exports = BilletValidationService;
